// extracted by mini-css-extract-plugin
export default {"progiumButton":"Button_progiumButton__pc9pu"};